module.exports = __webpack_public_path__ + "/img/QFP-Tc33GM.svg";